import HasLabel from "./HasLabel";
import { Permission } from "@/models/Permission";

export enum TeamMembershipSource {
    Manual = 0,
    GroupClaim = 1
}

export interface TeamUserDetail {
    userName: string;
    addedBy: TeamMembershipSource;
    addedDate: string;
    lastSyncDate?: string;
}

export interface Team {
    id: number;
    name: string;
    groupClaimName?: string;
    users: TeamUserDetail[];
    permissions: Permission[];
}

export class Team extends HasLabel {

    constructor(obj?: Team) {
        super();
        this.id = 0;

        if (obj) {
            Object.assign(this, obj);
            if (obj.permissions) {
                this.permissions = obj.permissions.map(p => new Permission(p));
            }
        }
    }

    toString(): string {
        if (this.name) {
            return this.name;
        }
        return '<div class="font-weight-light">Team</div>';
    }

    getLabel(): string {
        return this.toString();
    }

}
